import React from 'react';
import s from './Icon.scss';
const Icon = (p)=>/*#__PURE__*/ React.createElement("svg", {
        id: p.id,
        className: `${s.iconDefault} ${p.className}`,
        width: p.width || p.size,
        height: p.height || p.size,
        viewBox: p.viewBox
    }, p.children);
Icon.defaultProps = {
    size: '1em'
};
export default Icon;

//# sourceMappingURL=Icon.js.map